var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhoneNumber(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 45,
    height: 45,
    rx: 22.5,
    stroke: "white",
    strokeOpacity: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.5855 21.7918C21.4456 23.3029 22.6971 24.5544 24.2082 25.4145L25.0185 24.2797C25.1488 24.0972 25.3415 23.9688 25.5601 23.9188C25.7787 23.8688 26.008 23.9007 26.2047 24.0083C27.5011 24.7168 28.9329 25.143 30.4058 25.2587C30.6356 25.2769 30.8502 25.3811 31.0067 25.5505C31.1631 25.7198 31.25 25.942 31.25 26.1726V30.2628C31.25 30.4897 31.1659 30.7086 31.0138 30.8771C30.8618 31.0456 30.6526 31.1517 30.4268 31.1748C29.941 31.2252 29.4515 31.25 28.9583 31.25C21.1117 31.25 14.75 24.8883 14.75 17.0417C14.75 16.5485 14.7748 16.059 14.8252 15.5732C14.8483 15.3474 14.9544 15.1382 15.1229 14.9862C15.2914 14.8341 15.5103 14.75 15.7373 14.75H19.8274C20.058 14.75 20.2802 14.8369 20.4495 14.9933C20.6189 15.1498 20.7231 15.3644 20.7413 15.5943C20.857 17.0671 21.2832 18.4989 21.9917 19.7953C22.0993 19.992 22.1312 20.2213 22.0812 20.4399C22.0312 20.6585 21.9028 20.8512 21.7203 20.9815L20.5855 21.7918V21.7918ZM18.2737 21.1896L20.0153 19.9457C19.5211 18.8788 19.1824 17.7464 19.0097 16.5833H16.5925C16.587 16.7355 16.5842 16.8886 16.5842 17.0417C16.5833 23.8763 22.1237 29.4167 28.9583 29.4167C29.1114 29.4167 29.2645 29.4139 29.4167 29.4075V26.9903C28.2536 26.8176 27.1212 26.4789 26.0543 25.9847L24.8104 27.7263C24.3096 27.5317 23.8232 27.302 23.3548 27.0388L23.3016 27.0086C21.5036 25.9853 20.0147 24.4964 18.9914 22.6984L18.9612 22.6453C18.698 22.1768 18.4683 21.6904 18.2737 21.1896V21.1896Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneNumber);
export default __webpack_public_path__ + "static/media/phoneNumber.18522e9fee9a3fef8db78b418b03d847.svg";
export { ForwardRef as ReactComponent };